import { MoveRightIcon } from 'lucide-react';

import { Link as LinkComponent } from '@/components/Link/Link';

import styles from './Link.module.scss';

interface Props {
    label?: string;
    href: string;
}

export function Link({ href, label = 'Read story' }: Props) {
    return (
        <LinkComponent href={href} className={styles.link}>
            <span>{label}</span>
            <MoveRightIcon className={styles.icon} />
        </LinkComponent>
    );
}
